export default __webpack_public_path__ + "static/media/instagram.3a7decd5.png";